import React, { useState, useEffect } from "react";
import axios from "axios";
import { Notify } from "notiflix/build/notiflix-notify-aio";
import "bootstrap/dist/css/bootstrap.min.css";

export default function SupportMessages() {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);

    const base = process.env.REACT_APP_API_BASE_URL;

    const load = async () => {
        try {
            const token = sessionStorage.getItem("accessToken");
            const { data } = await axios.get(`${base}/admin/support-messages`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setMessages(data);
        } catch {
            Notify.failure("Не удалось загрузить обращения");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); }, []);

    if (loading) return <p className="text-center mt-4">Загрузка...</p>;

    return (
        <div className="mt-2">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Обращения в поддержку ({messages.length})</h5>
                <button className="btn btn-outline-primary btn-sm" onClick={load}>
                    Обновить
                </button>
            </div>

            {messages.length === 0 ? (
                <p className="text-center text-muted">Обращений пока нет</p>
            ) : (
                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead className="thead-light">
                            <tr>
                                <th>#</th>
                                <th>Имя</th>
                                <th>Email</th>
                                <th>Сообщение</th>
                                <th>Дата</th>
                            </tr>
                        </thead>
                        <tbody>
                            {messages.map((m) => (
                                <tr key={m.id}>
                                    <td>{m.id}</td>
                                    <td>{m.name}</td>
                                    <td>
                                        <a href={`mailto:${m.email}`}>{m.email}</a>
                                    </td>
                                    <td style={{ maxWidth: 400, whiteSpace: "pre-wrap" }}>
                                        {m.message}
                                    </td>
                                    <td style={{ whiteSpace: "nowrap" }}>
                                        {new Date(m.createdAt).toLocaleString("ru-RU")}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
